var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "h-100" },
                [
                  !_vm.powerOfAttorney
                    ? _c(
                        "label",
                        { staticClass: "btn w-100 mt-4 alert alert-dark" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("message.adminUserDocuments.uploadPoa")
                              ) +
                              "\n          "
                          ),
                          _c("input", {
                            attrs: {
                              type: "file",
                              hidden: "",
                              accept: "application/pdf, image/*"
                            },
                            on: { change: _vm.uploadPoa }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.powerOfAttorney
                            ? _c(
                                "b-btn",
                                {
                                  staticClass:
                                    "p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",
                                  attrs: { variant: "transparent" },
                                  on: { click: _vm.downloadPowerOfAttorney }
                                },
                                [
                                  _c(
                                    "b-alert",
                                    {
                                      staticClass:
                                        "rounded-0 certificate pb-0 mb-0",
                                      attrs: { show: "", variant: "dark" }
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          staticClass: "ti-printer mr-2"
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.adminUserDocuments.viewPoa"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _vm.powerOfAttorney
                            ? _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.delete-poa-modal",
                                      modifiers: { "delete-poa-modal": true }
                                    }
                                  ],
                                  staticClass: "mt-3",
                                  attrs: { variant: "danger" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.adminUserDocuments.deleteDocument"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "h-100" },
                [
                  !_vm.certificateOfDeath
                    ? _c(
                        "label",
                        { staticClass: "btn w-100 mt-4 alert alert-dark" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("message.adminUserDocuments.uploadCod")
                              ) +
                              "\n          "
                          ),
                          _c("input", {
                            attrs: {
                              type: "file",
                              hidden: "",
                              accept: "application/pdf, image/*"
                            },
                            on: { change: _vm.uploadCertificateOfDeath }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.certificateOfDeath
                            ? _c(
                                "b-btn",
                                {
                                  staticClass:
                                    "p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",
                                  attrs: { variant: "transparent" },
                                  on: { click: _vm.downloadCertificateOfDeath }
                                },
                                [
                                  _c(
                                    "b-alert",
                                    {
                                      staticClass:
                                        "rounded-0 certificate pb-0 mb-0",
                                      attrs: { show: "", variant: "dark" }
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          staticClass: "ti-printer mr-2"
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.adminUserDocuments.viewCod"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _vm.certificateOfDeath
                            ? _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.delete-cod-modal",
                                      modifiers: { "delete-cod-modal": true }
                                    }
                                  ],
                                  staticClass: "mt-3",
                                  attrs: { variant: "danger" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.adminUserDocuments.deleteDocument"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "h-100" },
                [
                  _c("b-form-select", {
                    staticClass: "mt-4",
                    attrs: { options: _vm.options },
                    on: { change: _vm.selectCp },
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.certificateOfInheritance && _vm.selected
                    ? _c(
                        "label",
                        { staticClass: "btn w-100 mt-4 alert alert-dark" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("message.adminUserDocuments.uploadCoi")
                              ) +
                              "\n          "
                          ),
                          _c("input", {
                            attrs: {
                              type: "file",
                              hidden: "",
                              accept: "application/pdf"
                            },
                            on: { change: _vm.uploadCertificateOfInheritance }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.certificateOfInheritance
                            ? _c(
                                "b-btn",
                                {
                                  staticClass:
                                    "p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",
                                  attrs: { variant: "transparent" },
                                  on: {
                                    click: _vm.downloadCertificateOfInheritance
                                  }
                                },
                                [
                                  _c(
                                    "b-alert",
                                    {
                                      staticClass:
                                        "rounded-0 certificate pb-0 mb-0",
                                      attrs: { show: "", variant: "dark" }
                                    },
                                    [
                                      _c("p", [
                                        _c("span", {
                                          staticClass: "ti-printer mr-2"
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.adminUserDocuments.viewCoi"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _vm.certificateOfInheritance
                            ? _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.delete-coi-modal",
                                      modifiers: { "delete-coi-modal": true }
                                    }
                                  ],
                                  staticClass: "mt-3",
                                  attrs: { variant: "danger" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.adminUserDocuments.deleteDocument"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-cod-modal",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.adminUserDocuments.modal.title"),
            "ok-title": _vm.$t("message.adminUserDocuments.modal.btn.ok"),
            "cancel-title": _vm.$t(
              "message.adminUserDocuments.modal.btn.cancel"
            )
          },
          on: { ok: _vm.deleteCertificateOfDeath }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.adminUserDocuments.modal.message")))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-coi-modal",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.adminUserDocuments.modal.title"),
            "ok-title": _vm.$t("message.adminUserDocuments.modal.btn.ok"),
            "cancel-title": _vm.$t(
              "message.adminUserDocuments.modal.btn.cancel"
            )
          },
          on: { ok: _vm.deleteCertificateOfInheritance }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.adminUserDocuments.modal.message")))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-poa-modal",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.adminUserDocuments.modal.title"),
            "ok-title": _vm.$t("message.adminUserDocuments.modal.btn.ok"),
            "cancel-title": _vm.$t(
              "message.adminUserDocuments.modal.btn.cancel"
            )
          },
          on: { ok: _vm.deletePowerOfAttorney }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.adminUserDocuments.modal.message")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dec000e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dec000e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUserDocuments.vue
// module id = wNHf
// module chunks = 1